import type { ColDef, GetQuickFilterTextParams, ValueGetterParams } from 'ag-grid-community'
import type { ClusterAppInfos } from '~/components/CellRenderers/ClusterApplicationCellRenderer'
import type { IClusterApp, IRecommendedClusterList } from '~/types/cluster'

import ClusterApplicationCellRenderer from '~/components/CellRenderers/ClusterApplicationCellRenderer'
import ClusterDecisionCellRenderer from '~/components/CellRenderers/DecisionCellRenderer'
import ScreenshotsCellRenderer from '~/components/CellRenderers/ScreenshotsCellRenderer'

const COLUMN_WIDTH = {
  EXTRA_LARGE: 700,
  LARGE: 300,
  SMALL: 130,
}

export const COLUMNS = {
  APPLICATION: 'app',
  DECISION: '',
  SCREENSHOTS: 'screenshots_url',
}

const columns: ColDef[] = [
  {
    cellRenderer: ClusterApplicationCellRenderer,
    comparator: (a: IClusterApp, b: IClusterApp): number => {
      if (!a.name?.length) return 1
      if (!b.name?.length) return -1

      return a.name?.toLowerCase().localeCompare(b.name?.toLowerCase())
    },
    field: COLUMNS.APPLICATION,
    filter: 'agTextColumnFilter',
    filterValueGetter: ({ data }: ValueGetterParams<ClusterAppInfos>): string => {
      const { name, product_id_data_ai, publisher_name, store_id } = data || {}
      return `${name || ''} ${product_id_data_ai || ''} ${publisher_name || ''} ${store_id || ''}`
    },
    getQuickFilterText: ({ value }: GetQuickFilterTextParams): string => value,
    headerName: 'Application',
    minWidth: COLUMN_WIDTH.SMALL,
    pinned: true,
    suppressSizeToFit: true,
    valueGetter: ({ data }: ValueGetterParams<IRecommendedClusterList>): ClusterAppInfos | undefined => {
      return data?.app
    },
    width: COLUMN_WIDTH.LARGE,
  },
  {
    cellRenderer: ScreenshotsCellRenderer,
    field: COLUMNS.SCREENSHOTS,
    headerName: 'Screenshots',
    menuTabs: [],
    sortable: false,
    suppressSizeToFit: true,
    valueGetter: ({ data }: ValueGetterParams<IRecommendedClusterList>): string[] => {
      return data?.app.screenshot_urls?.slice(0, 4) || []
    },
    width: COLUMN_WIDTH.EXTRA_LARGE,
  },
  {
    cellClass: 'decision-cell',
    cellRenderer: ClusterDecisionCellRenderer,
    field: COLUMNS.DECISION,
    headerName: 'Decision',
    sortable: false,
    suppressSizeToFit: true,
    width: COLUMN_WIDTH.LARGE,
  },
]
export default columns
